import { Component, EventListener, GondelBaseComponent } from '@gondel/core';
import {
	IValidatableInputComponent,
	ValidatableInputData,
} from '../../../../shared/utils/js/validatable-input.interface';

/**
 * textarea module implementation.
 * @author Srdan Turudic <srdan.turudic@merkle.com>
 */

enum Selectors {
	TextareaInput = '.js-a-textarea__input',
	Current = '.js-a-textarea__current',
	Hint = '.a-textarea__text',
}

enum States {
	Error = 'state-a-textarea--error',
}

@Component('Textarea')
export class Textarea extends GondelBaseComponent implements IValidatableInputComponent {
	private _textarea: HTMLTextAreaElement = {} as HTMLTextAreaElement;
	private _current: HTMLSpanElement = {} as HTMLSpanElement;
	private _hint: string = "";

	public start() {
		this._textarea = this._ctx.querySelector(Selectors.TextareaInput) as HTMLTextAreaElement;
		this._current = this._ctx.querySelector(Selectors.Current) as HTMLSpanElement;
		this._hint = this._ctx.querySelector(Selectors.Hint)?.innerHTML ?? '';
	}

	/**
	 * Display current char number in helper text
	 */
	@EventListener('keyup', Selectors.TextareaInput)
	public _onKeyPress(event: KeyboardEvent): void {
		if (event.key !== 'Tab') {
			this._isValid();
		}
	}

	/**
	 * Handle focusout
	 */
	@EventListener('focusout', Selectors.TextareaInput)
	public _onFocusOut(): void {
		this._isValid();
	}

	public getData(): ValidatableInputData {
		return new ValidatableInputData(this._textarea.name, this._textarea.value);
	}

	/**
	 * Handle validation
	 */
	public _isValid(): boolean {
		if (
			this._textarea.value.length > 0 &&
			this._textarea.hasAttribute('required') &&
			this._ctx.classList.contains(States.Error)
		) {
			this._ctx.classList.remove(States.Error);
			// reset hint if it was a be validation error shown
			(this._ctx.querySelector(Selectors.Hint) as HTMLSpanElement).innerHTML = this._hint;
			return true;
		} else if (
			this._textarea.value.length === 0 &&
			this._textarea.hasAttribute('required') &&
			!this._ctx.classList.contains(States.Error)
		) {
			this._ctx.classList.add(States.Error);
			return false;
		}

		return !this._ctx.classList.contains(States.Error);
	}

	public _showValidationErrorsByBe(data: any) {
		this._ctx.classList.add(States.Error);
		(this._ctx.querySelector(Selectors.Hint) as HTMLSpanElement).innerHTML = data.errors.join(' ');
	}
}
